import axios from '../../axios/index.js'

export default {
    list(data){
        return axios.get('/payrolls/list',{params:data})
    },
    statusList(){
        return axios.get('/payrolls/status_list')
    },
    getFile(id){
      return axios.get('/payrolls/getFile/' + id);
    }
}
